var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,0L90,0c3.1066,0,5.625,3.2236,5.625,7.2v30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2V7.2C84.375,3.2236,86.8934,0,90,0z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.9166666666666666s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.641-25.359L104.641-25.359c3.1066,0,5.625,3.2236,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2 l0,0c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C99.016-22.1355,101.5344-25.359,104.641-25.359z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.8333333333333334s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.6411-54.641L104.6411-54.641c3.1066,0,5.625,3.2236,5.625,7.2v30.6c0,3.9765-2.5184,7.2-5.625,7.2 l0,0c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C99.0161-51.4175,101.5345-54.641,104.6411-54.641z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.75s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90-80L90-80c3.1066,0,5.625,3.2235,5.625,7.2v30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2v-30.6C84.375-76.7765,86.8934-80,90-80z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.6666666666666666s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.641-94.6411L64.641-94.6411c3.1066,0,5.625,3.2235,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2 l0,0c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C59.016-91.4175,61.5344-94.6411,64.641-94.6411z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.5833333333333334s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.359-94.641L35.359-94.641c3.1066,0,5.625,3.2236,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C29.734-91.4175,32.2524-94.641,35.359-94.641z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.5s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10-80L10-80c3.1066,0,5.625,3.2235,5.625,7.2v30.6c0,3.9764-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2v-30.6C4.375-76.7765,6.8934-80,10-80z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.4166666666666667s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.641-54.641L-4.641-54.641c3.1066,0,5.625,3.2235,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C-10.266-51.4175-7.7476-54.641-4.641-54.641z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.3333333333333333s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.641-25.359L-4.641-25.359c3.1066,0,5.625,3.2236,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C-10.266-22.1354-7.7476-25.359-4.641-25.359z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.25s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0L10,0c3.1066,0,5.625,3.2236,5.625,7.2v30.6c0,3.9764-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2V7.2C4.375,3.2236,6.8934,0,10,0z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.16666666666666666s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.359,14.641L35.359,14.641c3.1066,0,5.625,3.2235,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C29.734,17.8646,32.2524,14.641,35.359,14.641z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "-0.08333333333333333s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.641,14.641L64.641,14.641c3.1066,0,5.625,3.2236,5.625,7.2l0,30.6c0,3.9765-2.5184,7.2-5.625,7.2l0,0 c-3.1066,0-5.625-3.2235-5.625-7.2l0-30.6C59.016,17.8646,61.5344,14.641,64.641,14.641z "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "1;0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBars);
export default __webpack_public_path__ + "static/media/circular-bars.2ed7a0d481302a6ea8a99fd1a8ded07a.svg";
export { ForwardRef as ReactComponent };